TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

module.exports = class Login extends TrelloModel
  typeName: 'Login'

  # Test if removing this credential will lock the member out of his or her
  # account.
  hasConflict: ->
    types = @collection.types()

    # If any of these tests pass, there is no conflict
    !_.any [
      # If this is has no login methods, then it is just an email association
      # for lookups.
      => _.isEmpty(@get('types'))

      # If we have a password there is never a conflict
      => 'password' of types

      # If none of the above are true, we need at least one other google
      # credential, or this is an important credential.
      => types.google >= 2
    ], (test) -> test()



// WEBPACK FOOTER //
// ./app/scripts/models/login.coffee